import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useCustomPageText = (param)=>{
    let { textId, enabled = true } = param;
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isEnabled = enabled && businessId != null && textId != null && textId !== '';
    const { data, isLoading, isError } = useQueryState({
        queryKey: [
            QueryKeys.CustomPageText,
            businessId,
            textId
        ],
        queryFn: async ()=>{
            const result = await api.customPage.getText(businessId, textId);
            return result.content;
        },
        enabled: isEnabled
    });
    return {
        content: data,
        isLoading: isEnabled && isLoading,
        isError
    };
};
